import MundialRequestTask from "./MundialRequestTask";

export class StandingsTask  extends MundialRequestTask {

  constructor() {
    super();
  }

  getUrl() {
    const baseUrl = this.getBaseUrl(); 
    return `${baseUrl}/leagues/${this.leagueId}/standings`;
  }

  getParams() {
    const params = super.getParams();
    return {
      ...params
    };
  }
}


// WEBPACK FOOTER //
// ./src/mundial/requests/tasks/StandingsTask.ts